// src/components/auth/PartnerAdminRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { usePartnerAdmin } from "@/contexts/PartnerAdminContext";

export default function PartnerAdminRoute({ children, requiredRole }) {
  const { membership, loading } = usePartnerAdmin();
  const token = localStorage.getItem("accessToken");

  if (!token) return <Navigate to="/login" replace />;

  if (loading) {
    return (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        minHeight: "100vh", background: "#0d0d0d", color: "#555",
        fontFamily: "monospace", fontSize: "13px",
      }}>
        loading...
      </div>
    );
  }

  if (!membership) {
    return (
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", minHeight: "100vh", background: "#0d0d0d",
        color: "#555", fontFamily: "monospace", gap: "12px",
      }}>
        <span style={{ fontSize: "13px" }}>Access denied.</span>
        <span style={{ fontSize: "11px", color: "#333" }}>
          No partner membership found for this account.
        </span>
      </div>
    );
  }

  if (requiredRole === "admin" && !membership.is_admin) {
    return (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        minHeight: "100vh", background: "#0d0d0d", color: "#555",
        fontFamily: "monospace", fontSize: "13px",
      }}>
        Admin access required.
      </div>
    );
  }

  return children;
}